import React, { useState } from "react";
import swal from "sweetalert";
import { API, ROUTER, STATIC } from "../../constants/env";
import Table from "../../components/Table/Table";
import { Button, Modal } from "react-bootstrap";

// Echappe les valeurs dynamiques injectees dans le document imprime
const escapeHtml = (value) =>
  String(value == null ? "" : value)
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#039;");

function ModalListStudent({ name, level, id }) {
  const [show, setShow] = useState(false);
  const [printing, setPrinting] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const [data, setData] = useState([]);
  const fields = [
    { title: "Photo d'éleve", field: "picture" },
    { title: "Prénom", field: "firstName" },
    { title: "Nom", field: "lastName" },
    { title: "Classe", field: "classe" },
    { title: "Parent", field: "parent" },
    { title: "Tél.", field: "phone" },
    { title: "Adresse", field: "adress" },
  ];
  // TODO : fetch should be work for specific classe
  // The Fetch Function
  const fetchData = (currentPage, count, search, setTotalPage, setTotal) => {
    fetch(
      API.students.list +
        `?specificClassId=${id}&page=${currentPage}&count=${count}&searchQuery=${search}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "x-auth-token": localStorage.getItem("token"),
        },
      }
    )
      .then((res) => res.json())
      .then((response) => {
        if (response.error) {
          return swal("Error", response.message, "error");
        }

        const results = response.data.map((elem) => ({
          _id: elem._id,
          picture: (
            <img
              src={STATIC.ROUTE(elem.profil.picture)}
              alt="student_pic"
              className="rounded imgWidthThumbnail"
            />
          ),
          firstName: elem.profil.firstName,
          lastName: elem.profil.lastName,
          classe: elem.classe ? elem.classe.name : "**Non défini**",
          parent: elem.parent
            ? `${elem.parent[0].profil.firstName} ${elem.parent[0].profil.lastName}`
            : "**Non défini**",
          phone: elem.profil.phone,
          adress: `${elem.profil.adress}`,
        }));
        setData(results);
        setTotalPage(response.totalPage);
        setTotal(response.total);
      })
      .catch((e) => {
        return swal("Error", e.message, "error");
      });
  };
  // End Fetche

  // Recupere la liste complete de la classe (toutes pages) pour l'impression
  const fetchAllStudents = () => {
    return fetch(
      API.students.list +
        `?specificClassId=${id}&page=1&count=1000&searchQuery=`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "x-auth-token": localStorage.getItem("token"),
        },
      }
    )
      .then((res) => res.json())
      .then((response) => {
        if (response.error) {
          throw new Error(response.message);
        }
        return response.data || [];
      });
  };

  // Construit le document HTML propre (entete + detail) et lance l'impression
  const buildPrintDocument = (students) => {
    const logoUrl = `${window.location.origin}/assets/images/odysse.png`;
    const now = new Date();
    const printedAt = now.toLocaleDateString("fr-FR", {
      day: "2-digit",
      month: "long",
      year: "numeric",
    });

    const rows = students
      .map((elem, index) => {
        const p = elem.profil || {};
        const firstName = escapeHtml(p.firstName);
        const lastName = escapeHtml(p.lastName);
        const parent =
          elem.parent && elem.parent[0]
            ? escapeHtml(
                `${elem.parent[0].profil.firstName} ${elem.parent[0].profil.lastName}`
              )
            : "—";
        const phone = escapeHtml(p.phone) || "—";
        const adress = escapeHtml(p.adress) || "—";
        return `
          <tr>
            <td class="c-num">${index + 1}</td>
            <td>${lastName}</td>
            <td>${firstName}</td>
            <td>${parent}</td>
            <td class="c-phone">${phone}</td>
            <td>${adress}</td>
          </tr>`;
      })
      .join("");

    const emptyRow = `
      <tr><td colspan="6" class="c-empty">Aucun élève dans cette classe.</td></tr>`;

    return `<!DOCTYPE html>
<html lang="fr">
<head>
  <meta charset="utf-8" />
  <title>Liste des élèves - ${escapeHtml(name)}</title>
  <style>
    * { box-sizing: border-box; }
    body {
      font-family: "Segoe UI", Arial, sans-serif;
      color: #1f2937;
      margin: 0;
      padding: 28px 32px;
    }
    .header {
      display: flex;
      align-items: center;
      justify-content: space-between;
      border-bottom: 3px solid #4f46e5;
      padding-bottom: 16px;
      margin-bottom: 20px;
    }
    .header .brand { display: flex; align-items: center; gap: 16px; }
    .header img { height: 68px; width: auto; }
    .header .school-name { font-size: 22px; font-weight: 700; color: #111827; }
    .header .school-sub { font-size: 13px; color: #6b7280; margin-top: 2px; }
    .header .meta { text-align: right; font-size: 12px; color: #6b7280; }
    .header .meta strong { color: #374151; }
    .title-block {
      display: flex;
      justify-content: space-between;
      align-items: flex-end;
      margin-bottom: 14px;
    }
    .title-block h1 { font-size: 18px; margin: 0; color: #111827; }
    .title-block .effectif {
      font-size: 13px;
      background: #eef2ff;
      color: #4338ca;
      padding: 5px 12px;
      border-radius: 6px;
      font-weight: 600;
    }
    table { width: 100%; border-collapse: collapse; font-size: 12.5px; }
    thead th {
      background: #4f46e5;
      color: #fff;
      text-align: left;
      padding: 9px 10px;
      font-weight: 600;
    }
    tbody td { padding: 8px 10px; border-bottom: 1px solid #e5e7eb; }
    tbody tr:nth-child(even) { background: #f9fafb; }
    .c-num { text-align: center; width: 40px; color: #6b7280; }
    .c-phone { white-space: nowrap; }
    .c-empty { text-align: center; color: #6b7280; padding: 24px; }
    .footer {
      margin-top: 40px;
      display: flex;
      justify-content: space-between;
      font-size: 12px;
      color: #374151;
    }
    .footer .sign { text-align: center; }
    .footer .sign .line {
      margin-top: 48px;
      border-top: 1px solid #9ca3af;
      padding-top: 4px;
      min-width: 200px;
    }
    @media print {
      body { padding: 0; }
      thead { display: table-header-group; }
      tr { page-break-inside: avoid; }
    }
  </style>
</head>
<body>
  <div class="header">
    <div class="brand">
      <img src="${logoUrl}" alt="Logo" onerror="this.style.display='none'" />
      <div>
        <div class="school-name">École Odyssée</div>
        <div class="school-sub">Liste des élèves par classe</div>
      </div>
    </div>
    <div class="meta">
      <div>Imprimé le <strong>${printedAt}</strong></div>
    </div>
  </div>

  <div class="title-block">
    <h1>Classe : ${escapeHtml(name.toUpperCase())} — Niveau : ${escapeHtml(
      level.toUpperCase()
    )}</h1>
    <div class="effectif">Effectif : ${students.length} élève(s)</div>
  </div>

  <table>
    <thead>
      <tr>
        <th class="c-num">N°</th>
        <th>Nom</th>
        <th>Prénom</th>
        <th>Parent</th>
        <th>Téléphone</th>
        <th>Adresse</th>
      </tr>
    </thead>
    <tbody>
      ${students.length ? rows : emptyRow}
    </tbody>
  </table>

  <div class="footer">
    <div>École Odyssée — Document généré automatiquement</div>
    <div class="sign">
      <div class="line">Signature &amp; cachet</div>
    </div>
  </div>
</body>
</html>`;
  };

  const handlePrint = async () => {
    if (printing) return;
    setPrinting(true);
    // Ouvrir la fenetre tout de suite (evite le blocage popup apres await)
    const printWindow = window.open("", "_blank", "width=900,height=650");
    if (!printWindow) {
      setPrinting(false);
      return swal(
        "Impression bloquée",
        "Autorisez les fenêtres pop-up pour imprimer la liste.",
        "warning"
      );
    }
    try {
      const students = await fetchAllStudents();
      printWindow.document.open();
      printWindow.document.write(buildPrintDocument(students));
      printWindow.document.close();
      printWindow.focus();
      // Laisse le logo/DOM se charger avant l'impression
      setTimeout(() => {
        printWindow.print();
      }, 350);
    } catch (e) {
      printWindow.close();
      swal("Error", e.message, "error");
    } finally {
      setPrinting(false);
    }
  };

  const handleDataShow = () => {
    handleShow();
  };
  return (
    <>
      <Button variant="btn btn-primary mr-2" onClick={() => handleDataShow()}>
        afficher la liste des élèves
      </Button>

      <Modal
        show={show}
        onHide={handleClose}
        size="lg"
        centered
        aria-labelledby="contained-modal-title-vcenter"
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            La liste des élèves
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Table
            editRoute={(id) => ROUTER.STUDENTS.EDIT(id)}
            deleteApiRoute={API.students.remove}
            deleteMultiple={API.students.deleteMultiple}
            fetchData={fetchData}
            name={`Les élèves de la classe: ${name.toUpperCase()} Niveau: ${level.toUpperCase()}`}
            fields={fields}
            data={data}
            showSearch={true}
          />
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="success"
            onClick={handlePrint}
            disabled={printing}
          >
            <i className="fa fa-print mr-2" />
            {printing ? "Préparation..." : "Imprimer la liste"}
          </Button>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default ModalListStudent;
